import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { cn } from "@/lib/utils";
import { format } from "date-fns";
import { CalendarIcon } from "lucide-react";
import { useState } from "react";

interface DashboardFiltersProps {
  startDate: string;
  endDate: string;
  onFilterChange: (start: string, end: string) => void;
}

export function DashboardFilters({
  startDate,
  endDate,
  onFilterChange,
}: DashboardFiltersProps) {
  const [date, setDate] = useState<{ from: Date; to: Date } | undefined>({
    from: new Date(startDate),
    to: new Date(endDate),
  });

  const handleSelect = (range: any) => {
    setDate(range);
    if (range?.from && range?.to) {
      onFilterChange(
        range.from.toISOString().split("T")[0],
        range.to.toISOString().split("T")[0]
      );
    }
  };

  return (
    <div className="flex items-center space-x-2">
      <Popover>
        <PopoverTrigger asChild>
          <Button
            variant={"outline"}
            className={cn(
              "w-[280px] justify-start text-left font-normal",
              !date && "text-muted-foreground"
            )}
          >
            <CalendarIcon className="mr-2 h-4 w-4" />
            {date?.from ? (
              date.to ? (
                <>
                  {format(date.from, "LLL dd, y")} -{" "}
                  {format(date.to, "LLL dd, y")}
                </>
              ) : (
                format(date.from, "LLL dd, y")
              )
            ) : (
              <span>Pick a date range</span>
            )}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align="end">
          <Calendar
            initialFocus
            mode="range"
            defaultMonth={date?.from}
            selected={date}
            onSelect={handleSelect}
            numberOfMonths={2}
          />
        </PopoverContent>
      </Popover>
    </div>
  );
}
